import { initDropdowns } from './dropdowns';
import { initAppsMenus } from './appsMenu';
import { attachScrollGuards } from './scrollGuards';
import { updateAllBadges } from './badges';

// Bootstraps all interactive behaviors inside the shadow root and returns a cleanup aggregator.
export function initBehaviors(root: ShadowRoot): () => void {
  const cleanups: Array<() => void> = [];

  cleanups.push(initDropdowns(root));
  cleanups.push(initAppsMenus(root));
  cleanups.push(attachScrollGuards(root));
  updateAllBadges(root);

  return () =>
    cleanups.forEach((fn) => {
      try { fn(); } catch {}
    });
}
